import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { HttpClient } from '@angular/common/http';
import { DashboardSidebarService } from '../../services/sidebar.service';
export interface RecentItem {
  doctorName: string;
  title: string;
  date: string;
  status: 'Completed' | 'Cancelled' | 'Upcoming';
  time: string
}

@Component({
  selector: 'patient-recent-appointments',
  standalone: true,
  imports: [CommonModule, SidebarModule],
  templateUrl: './recent-appointments.component.html',
  styleUrls: ['./recent-appointments.component.scss']
})
export class RecentAppointmentsComponent {
  @Input() items: RecentItem[] = [];
  @Output() appointmentClick = new EventEmitter<RecentItem>();


    constructor(private router: Router,
      private sidebarSerivce : DashboardSidebarService,
      private http : HttpClient
    ) {}
   onClick(item : RecentItem) {
    //  console.log(`item from recent`,item)
     this.sidebarSerivce.showSidebar(item);

    // this.router.navigate(['/appointment-details'], { state: { details: item } });
    // this.sidebarVisible1 = true
  }

  sidebarVisible1: boolean = false;


  }

